/* eslint-disable react/forbid-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {
    IconFormatBold,
    IconFormatItalic,
    IconFormatListBulleted,
    IconRedo,
    IconUndo
} from '../icons/Icons';

export function EditorButton({ children, isActive, ...props }) {
    return (
        <button
            className={cx('sarsa-rich-text-editor-button', {
                active: isActive
            })}
            {...props}>
            <span className="sarsa-rich-text-editor-button-inner">
                {children}
            </span>
        </button>
    );
}

EditorButton.propTypes = {
    children: PropTypes.node,
    isActive: PropTypes.bool
};



export function InlineComponent({ onChange, currentState, config }) {
    return (
        <>
            {config.options.includes('bold') && (
                <EditorButton
                    aria-label="Bold"
                    title="Bold"
                    onClick={() => onChange('Bold')}
                    isActive={currentState.bold}>
                    <IconFormatBold size="md" />
                </EditorButton>
            )}
            {config.options.includes('italic') && (
                <EditorButton
                    aria-label="Italic"
                    title="Italic"
                    onClick={() => onChange('Italic')}
                    isActive={currentState.italic}>
                    <IconFormatItalic size="md" />
                </EditorButton>
            )}

        </>

    );
}

InlineComponent.propTypes = {
    onChange: PropTypes.func,
    currentState: PropTypes.object,
    config: PropTypes.object
};



export function ListComponent({ onChange, currentState: { listType }, config }) {
    return (
        <>
            {config.options.includes('unordered') && (
                <EditorButton
                    aria-label="Unordered list"
                    title="Unordered list"
                    onClick={() => onChange('unordered')}
                    isActive={listType === 'unordered'}>
                    <IconFormatListBulleted size="md" />
                </EditorButton>
            )}
        </>

    );
}

ListComponent.propTypes = {
    onChange: PropTypes.func,
    currentState: PropTypes.object,
    config: PropTypes.object
};



export function HistoryComponent({
    onChange,
    currentState: { undoDisabled, redoDisabled },
    config
}) {
    return (
        <>
            {config.options.includes('undo') && (
                <EditorButton
                    aria-label="Undo"
                    title="Undo"
                    disabled={undoDisabled}
                    onClick={() => onChange('undo')}>
                    <IconUndo size="md" />
                </EditorButton>
            )}
            {config.options.includes('redo') && (
                <EditorButton
                    aria-label="Undo"
                    title="Undo"
                    disabled={redoDisabled}
                    onClick={() => onChange('redo')}>
                    <IconRedo size="md" />
                </EditorButton>
            )}
        </>

    );
}

HistoryComponent.propTypes = {
    onChange: PropTypes.func,
    currentState: PropTypes.object,
    config: PropTypes.object
};
